import _ from 'lodash';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import constants from '../../../config/constants';
import { withCart } from '../../../utils/CartContext';
import { noop } from '../../../utils/noop';
import { renderOOSView } from '../common';
import { DeliveryOptionsModal } from '../DeliveryOptions/DeliveryOptionsModal';
import DeliveryOptionsSelectedText from '../DeliveryOptions/DeliveryOptionsSelectedText';
import { AvailabilityMobileStyles } from './AvailabilityMobile.style';

const {
  // COOKIE_HOME_DELIVERY_KEY,
  // COOKIE_STORE_PICKUP_KEY,
  // LS_HOME_DELIVERY_KEY,
  // LS_STORE_PICKUP_KEY,
  // AVAILABILITY_HOMEDELIVERY,
  AVAILABILITY_OUTOFSTOCK,
  AVAILABILITY_ICON_CLASS_MAPPER,
} = constants;

const AvailabilityMobileItem = ({
  appCtxData,
  availability,
  labelsData,
  isLast,
  hasModal,
  sizes,
  colorVariants,
  cart,
  availabilityList,
  deliveryData,
  deliveryActions,
  selectedType,
  setSelectedType,
  textGenerated,
  deliveryErrors,
  productData,
  variantData,
  shippingOptionType,
  zoneConfig,
  setZoneConfig,
  setSelectedDeliveryOption,
  selectedDeliveryOption,
  labelsKey,
}) => {
  const { stateOfStock } = availability;
  const { showShippingModal } = productData;
  const { isSizeSelected } = cart;
  const { isDefaultComuna } = appCtxData;

  const {
    // localStorageComunaKey,
    // localStorageRegionKey,
    // localStorageCiudadKey,
    // localAvailableTextDisplayKey,
    // subPrefix,
    outOfStock,
  } = labelsKey;

  const isOutOfStock = stateOfStock === AVAILABILITY_OUTOFSTOCK;

  // const [selectedCommuna, setSelectedCommuna] = useState();
  const [modalVisible, setModalVisible] = useState(false);

  // const { comuna, displayText } = useRegionComuna({
  //   modalVisible,
  //   lsComunaKey: localStorageComunaKey,
  //   lsRegionKey: localStorageRegionKey,
  //   lsCiudadKey: localStorageCiudadKey,
  //   displayKey: localAvailableTextDisplayKey,
  // });

  const comunaName = _.get(zoneConfig, isDefaultComuna ? 'comunaName' : 'name', '');
  const persistedText = textGenerated[shippingOptionType];

  // useEffect(() => {
  //   setSelectedCommuna(
  //     getSelectedCommuna({
  //       shippingOptionType,
  //       AVAILABILITY_HOMEDELIVERY,
  //       COOKIE_HOME_DELIVERY_KEY,
  //       COOKIE_STORE_PICKUP_KEY,
  //       LS_HOME_DELIVERY_KEY,
  //       LS_STORE_PICKUP_KEY,
  //     })
  //   );
  // }, []);

  const handleItemClick = useCallback(() => {
    setModalVisible(true);
    setSelectedType(shippingOptionType);
  }, [shippingOptionType, selectedType, setSelectedType]);

  const getDeliveryModal = useCallback(() => {
    return (
      <DeliveryOptionsModal
        type={shippingOptionType}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        zoneConfig={zoneConfig}
        setZoneConfig={setZoneConfig}
        sizes={sizes}
        colorVariants={colorVariants}
        selectedDeliveryOption={selectedDeliveryOption}
        setSelectedDeliveryOption={setSelectedDeliveryOption}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        cart={cart}
        availabilityList={availabilityList}
        deliveryData={deliveryData}
        deliveryActions={deliveryActions}
        deliveryErrors={deliveryErrors}
        appCtxData={appCtxData}
        productData={productData}
        variantData={variantData}
        labelsData={labelsData}
        outOfStock={outOfStock}
      />
    );
  }, [
    shippingOptionType,
    modalVisible,
    setModalVisible,
    zoneConfig,
    setZoneConfig,
    sizes,
    colorVariants,
    selectedDeliveryOption,
    setSelectedDeliveryOption,
    isSizeSelected,
    selectedType,
    setSelectedType,
    cart,
    availabilityList,
    deliveryData,
    deliveryActions,
    deliveryErrors,
    appCtxData,
    productData,
    variantData,
    labelsData,
  ]);

  return (
    <>
      {hasModal && modalVisible && getDeliveryModal()}
      <div
        className={`availability-item ${isLast && 'lastItem'} rebranded`}
        onKeyDown={noop}
        role="button"
        tabIndex={0}
        onClick={handleItemClick}
      >
        <div className={`icon ${AVAILABILITY_ICON_CLASS_MAPPER[shippingOptionType]}`} />
        <div className={`content ${isOutOfStock ? 'outofstock' : ''}`}>
          {!isOutOfStock
            ? showShippingModal && (
                <>
                  {/* {comuna.name && <span>{labelsData[`${subPrefix}`]} </span>} */}
                  <div id={`testId-Availability-Mobile-ModalOpen-${shippingOptionType}`}>
                    {persistedText && (
                      <DeliveryOptionsSelectedText
                        textData={persistedText}
                        labelsData={labelsData}
                        labelsKey={labelsKey}
                      />
                    )}
                  </div>
                </>
              )
            : renderOOSView({
                labelsData,
                outOfStock,
                comunaName,
                parentStateName: zoneConfig.parentStateName,
                styles: AvailabilityMobileStyles,
              })}
        </div>

        <style jsx>{AvailabilityMobileStyles}</style>
      </div>
    </>
  );
};

AvailabilityMobileItem.propTypes = {
  availability: PropTypes.object.isRequired,
  labelsData: PropTypes.object.isRequired,
  isLast: PropTypes.bool,
  hasModal: PropTypes.bool,
  appCtxData: PropTypes.object.isRequired,
  productData: PropTypes.object.isRequired,
  sizes: PropTypes.array,
  colorVariants: PropTypes.array,
  cart: PropTypes.object.isRequired,
  availabilityList: PropTypes.array.isRequired,
  deliveryData: PropTypes.object,
  deliveryActions: PropTypes.object.isRequired,
  selectedType: PropTypes.string.isRequired,
  setSelectedType: PropTypes.func.isRequired,
  textGenerated: PropTypes.object.isRequired,
  deliveryErrors: PropTypes.object,
  variantData: PropTypes.object.isRequired,
  shippingOptionType: PropTypes.string.isRequired,
  zoneConfig: PropTypes.object.isRequired,
  setZoneConfig: PropTypes.func.isRequired,
  selectedDeliveryOption: PropTypes.object.isRequired,
  setSelectedDeliveryOption: PropTypes.func.isRequired,
  labelsKey: PropTypes.object.isRequired,
};

AvailabilityMobileItem.defaultProps = {
  isLast: false,
  hasModal: true,
  sizes: [],
  colorVariants: [],
  deliveryData: {},
  deliveryErrors: {
    PickupInStore: { isError: false, code: null },
    HomeDelivery: { isError: false, code: null },
    StockInStore: { isError: false, code: null },
  },
};

export { AvailabilityMobileItem };
export default withCart(AvailabilityMobileItem);
